import cn from 'classnames';
import { FCX } from "@datassential/platform-ui-lib";
import Skeleton, { SkeletonShape } from "@components/Skeleton";

const TableCellLoading: FCX<{
	onClick?: () => void;
	attrs?: any;
}> = ({
	onClick,
	className,
	style,
	attrs,
}) => {
	return (
		<div
			{...attrs}
			className={cn("TableCell", className)}
			style={style}
			onClick={onClick}
		>
			<Skeleton
				shape={SkeletonShape.Text}
				height={20}
				radius={4}
			/>
		</div>
	);
};

export default TableCellLoading;